import React from "react";
import PropTypes from "prop-types";

import { useForgotPasswordForm } from "scenes/Authentication/hooks";

import { Layout } from "..";
import { ForgotPasswordForm } from "./components";

export function ForgotPasswordPage({ onDone }) {
  const { forgot, loading, error } = useForgotPasswordForm(onDone);

  return (
    <div data-test="forgot-password-form">
      <Layout
        errorMessage={error}
        infoMessage={
          <div data-test="reset-info-message" style={{ textAlign: "center" }}>
            <div
              style={{
                fontSize: "24px",
                fontWeight: "700",
                lineHeight: "normal",
              }}
            >
              Reset your password
            </div>
            <div>
              Enter the email associated with your account and we will send you
              a verification code to reset your email
            </div>
          </div>
        }
      >
        <ForgotPasswordForm loading={loading} onSubmit={forgot} />
      </Layout>
    </div>
  );
}

ForgotPasswordPage.propTypes = {
  onDone: PropTypes.func.isRequired,
};

export default ForgotPasswordPage;
